import dateformat from 'dateformat';

import getLocusUrlString from './get-locus-url-string';
import {defaultPartner} from '@stencil/hotels-config/src/config/app-config';
import {isValidDate, parseUrlDatesWithUnderScore} from './date-utils/date-utils';

export const getNewValidDate = ({
  date,
  stringToCheck = 'date_',
}: {
  date: string | Date;
  stringToCheck?: string;
}): Date => {
  if (typeof date === 'string' && date.startsWith(stringToCheck)) {
    const parsedDate = parseUrlDatesWithUnderScore({
      dateString: date,
      today: new Date(),
      stringToCheck,
      defaultOffset: 1,
    });
    return isValidDate(parsedDate) ? parsedDate : new Date();
  }

  return isValidDate(date) ? (date as Date) : new Date();
};

export const getNewUrl = (
  {
    checkin,
    checkout,
    roomString,
    destination,
    locus = {},
    partner = defaultPartner,
    country = '',
    newFilterData = '',
    newLocationData = '',
    hotelId = '',
    mmtId = '',
    _uCurrency: currency = 'INR',
    cmp = '',
    sort = '',
    openSRPForHotelSearch = false,
    propertyId = '',
    propertyName = '',
    searchText = '',
    funnel = '',
    newSelectedSlot = '',
    checkinTime = '',
    city = '',
    fcSlotId = '',
    topHtlId = '',
    sType = '',
  },
  pageType = 'srp',
) => {
  const searchTextName =
    city || propertyName || destination?.name || destination?.n || searchText || '';
  const checkIn_date = getNewValidDate({date: checkin.date});
  const checkOut_date = getNewValidDate({date: checkout?.date});

  const CI = `checkin=${dateformat(checkIn_date, 'yyyymmdd')}`;
  const CO = checkout ? `&checkout=${dateformat(checkOut_date, 'yyyymmdd')}` : '';
  const RS = roomString ? `&roomString=${roomString}` : '';
  const locusUrlStr = getLocusUrlString(locus);
  const cc = country ? `&cc=${country}` : '';
  const filterData = newFilterData ? `&filterData=${newFilterData}` : '';
  const locationData = newLocationData ? `&locationData=${newLocationData}` : '';
  const searchTextValue = searchTextName ? `&searchText=${searchTextName}` : '';
  const _uCurrency = currency ? `&_uCurrency=${currency}` : '';
  const cmpValue = cmp ? `&cmp=${cmp}` : '';
  const hotelMMTId = mmtId ? `&mmtId=${mmtId}` : '';
  const hotelID = (openSRPForHotelSearch && hotelId && `&hotelId=${hotelId}`) || '';
  const sortApplied = !!sort ? `&sort=${sort}` : '';
  const vcid = destination?._id ? `&vcid=${destination._id}` : '';
  const giHotelId = propertyId ? `&giHotelId=${propertyId}` : '';
  const funnelValue = funnel ? `&funnel=${funnel}` : '';
  const slotValue = newSelectedSlot ? `&slot=${newSelectedSlot}` : '';
  const hourKeyValue = checkinTime ? `&hourKey=${checkinTime}` : '';
  const flexibleCheckinSlotId = fcSlotId ? `&fcSlotId=${fcSlotId}` : '';
  const topHtlIdValue = topHtlId ? `&topHtlId=${topHtlId}` : '';
  const sTypeValue = sType ? `&sType=${sType}` : '';

  let path = '';
  switch (pageType) {
    case 'srp':
      path = 'hotel-listing';
      break;
    case 'hourlySrp':
      path = 'hotel-hourly-listing';
      break;
    case 'hourlyDetail':
      path = 'hotel-hourly-details';
      break;
    case 'details':
      path = 'hotel-details';
      break;
    default:
      path = 'hotel-listing';
  }

  return `/${partner}/${path}/?${CI}${CO}${RS}${searchTextValue}${locusUrlStr}${cc}${_uCurrency}${vcid}${giHotelId}${filterData}${locationData}${sortApplied}${hotelMMTId}${hotelID}${cmpValue}${funnelValue}${slotValue}${hourKeyValue}${flexibleCheckinSlotId}${topHtlIdValue}${sTypeValue}`;
};
